var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 85,
    viewBox: "0 0 347 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.165 46.1522H51.9409V68.5739H346.165V46.1522Z",
    fill: "#222532",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.112 79.3798H171.275V84.9479H327.112V79.3798Z",
    fill: "#222532",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.894 0H162.056V5.56896H317.894V0Z",
    fill: "#222532",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.842 22.9901H0V31.1767H291.842V22.9901Z",
    fill: "#222532",
    fillOpacity: 0.24
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBg);
export default __webpack_public_path__ + "static/media/leftBg.8d5c7f20eb96fece8b88e8d0eb233575.svg";
export { ForwardRef as ReactComponent };